<template>
  <b-dropdown
    v-if="config"
    variant="outline-primary"
    :text="selectedTeamText">
    <b-dropdown-item
      v-if="config.mlb"
      :variant="config.mlb._variant || 'dark'"
      :active="selectedTeamID === config.mlb.teamCode"
      @click.prevent="onTeamSelected(config.mlb)">
      {{ config.mlb.clubFullName }}
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      v-for="it in config.allstarTeams"
      :key="it.teamID"
      :variant="it._variant || 'dark'"
      :active="selectedTeamID === it.teamCode"
      @click.prevent="onTeamSelected(it)">
      {{ it.clubFullName }}
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      v-for="it in config.teams"
      :key="it.teamID"
      :variant="it._variant || 'dark'"
      :active="selectedTeamID === it.teamCode"
      @click.prevent="onTeamSelected(it)">
      {{ it.clubFullName }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    name: "TeamPicker",
    props: {
      config: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      selectedTeamID: null,
    }),
    computed: {
      selectedTeamText() {
        if (this.selectedTeamID === null) {
          return "Choose a Team"
        }

        const teams = [
          this.config.mlb,
          ...this.config.allstarTeams,
          ...this.config.teams,
        ]
        for (const team of teams) {
          if (team.teamID === this.selectedTeamID) {
            return team.clubFullName
          }
        }
        return "Choose a Team"
      },
    },
    methods: {
      onTeamSelected(selected) {
        this.selectedTeamID = selected.teamID
        this.$emit('on-team-selected', selected)
      },
    },
  }
</script>

<style scoped>

</style>
